import MuiCheckbox from '@mui/material/Checkbox';

type CheckboxProps = React.ComponentProps<typeof MuiCheckbox>;

export default function Checkbox(props: Readonly<CheckboxProps>) {
  return <MuiCheckbox {...props} />;
}
